import { HttpClient } from '@remodeling/base';
import { GetChatbotTokenResponse } from '../../model/dto/chatbot';

export class GetChatbotTokenGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetChatbotTokenResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/order-service/api/mall/v1/orders/chatbot/token`,
    });
  }
}
